import { ReactNode } from "react";
import { Redirect } from "wouter";
import { useAuth } from "@/hooks/use-auth";

interface PortfolioOnlyRouteProps {
  children: ReactNode;
}

export function PortfolioOnlyRoute({ children }: PortfolioOnlyRouteProps) {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  // Admin is not admitted: every /api/portfolio/* query is scoped to the logged-in manager
  if (user && user.role !== "portfolio_manager") {
    return <Redirect to="/unauthorized" />;
  }

  return <>{children}</>;
}
